import { createTheme } from '@mui/material/styles';
import { secondary } from './colors';
const theme = createTheme();
const shadows = [...theme.shadows];
shadows[1] = '0px 0px 1px 0px rgba(32, 35, 39, 0.16), 0px 4px 8px 0px rgba(32, 35, 39, 0.04), 0px 8px 48px 0px rgba(32, 35, 39, 0.02)';
shadows[2] = '0px -1px 2px rgba(0, 0, 0, 0.08), 0px 1px 10px rgba(49, 49, 153, 0.4)';
shadows[3] = `inset 0 0 0 2px ${secondary.light}, inset 0 0 0 3px #FFFFFF`;
shadows[8] = '0px 8px 24px rgba(0, 0, 0, 0.08), 0px 0px 24px rgba(49, 49, 153, 0.16)';
export default shadows;